import React, { useState } from 'react';
import styles from './DeleteCandidateAccount.module.css';

const DeleteCandidateAccount = () => {
    const [formData, setFormData] = useState({
        phone: '',
        email: '',
        reason: '',
        confirmation: false
    });
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validation
        if (!formData.phone || !formData.email) {
            setError('कृपया फोन नंबर और ईमेल दोनों भरें / Please fill both phone and email');
            return;
        }

        if (!formData.confirmation) {
            setError('कृपया पुष्टि करें कि आप अपना अकाउंट डिलीट करना चाहते हैं / Please confirm you want to delete your account');
            return;
        }

        setLoading(true);

        try {
            // Replace with your actual API endpoint
            const response = await fetch('/api/delete-account-request', {
                method: 'POST',
                body: JSON.stringify(formData)
            });

            if (!response.ok) {
                setSubmitted(true);
            } else {
                throw new Error('Request failed');
            }
        } catch (err) {
            setError('कुछ गलत हो गया। कृपया बाद में पुनः प्रयास करें / Something went wrong. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    if (submitted) {
        return (
            <div className={styles.container}>
                <div className={styles.successCard}>
                    <div className={styles.successIcon}>✓</div>
                    <h1 className={styles.successTitle}>अनुरोध सफलतापूर्वक प्राप्त हुआ</h1>
                    <h2 className={styles.successSubtitle}>Request Received Successfully</h2>
                    <div className={styles.successMessage}>
                        <p>आपका अकाउंट डिलीट करने का अनुरोध हमें मिल गया है।</p>
                        <p>Your account deletion request has been received.</p>
                        <p className={styles.timeline}>
                            हम 7-10 कार्य दिवसों के भीतर आपके अकाउंट को स्थायी रूप से डिलीट कर देंगे।
                        </p>
                        <p className={styles.timeline}>
                            We will permanently delete your account within 7-10 business days.
                        </p>
                        <p className={styles.confirmationNote}>
                            आपको ईमेल पर पुष्टि संदेश भेजा जाएगा।<br />
                            A confirmation email will be sent to you.
                        </p>
                    </div>
                    <a href="/" className={styles.homeButton}>
                        होमपेज पर वापस जाएं / Back to Homepage
                    </a>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <div className={styles.card}>
                <div className={styles.header}>
                    <h1 className={styles.title}>अकाउंट डिलीट करें</h1>
                    <h2 className={styles.subtitle}>Delete Account</h2>
                </div>

                <div className={styles.infoSection}>
                    <div className={styles.warningBox}>
                        <span className={styles.warningIcon}>⚠️</span>
                        <div>
                            <p className={styles.warningText}>
                                <strong>चेतावनी / Warning:</strong> यह क्रिया स्थायी है और इसे पूर्ववत नहीं किया जा सकता।
                            </p>
                            <p className={styles.warningText}>
                                This action is permanent and cannot be undone.
                            </p>
                        </div>
                    </div>

                    <div className={styles.dataInfo}>
                        <h3 className={styles.sectionTitle}>डिलीट होने वाला डेटा / Data That Will Be Deleted:</h3>
                        <ul className={styles.dataList}>
                            <li>आपकी प्रोफाइल जानकारी / Your profile information</li>
                            <li>सेव किए गए जॉब्स / Saved jobs</li>
                            <li>जॉब एप्लीकेशन हिस्ट्री / Job application history</li>
                            <li>संदेश और चैट / Messages and chats</li>
                            <li>सभी व्यक्तिगत डेटा / All personal data</li>
                        </ul>
                    </div>

                    <div className={styles.processingInfo}>
                        <h3 className={styles.sectionTitle}>प्रक्रिया समय / Processing Time:</h3>
                        <p>आपका अकाउंट 7-10 कार्य दिवसों के भीतर स्थायी रूप से डिलीट कर दिया जाएगा।</p>
                        <p>Your account will be permanently deleted within 7-10 business days.</p>
                    </div>
                </div>

                <form onSubmit={handleSubmit} className={styles.form}>
                    <div className={styles.formGroup}>
                        <label className={styles.label}>
                            मोबाइल नंबर / Mobile Number <span className={styles.required}>*</span>
                        </label>
                        <input
                            type="tel"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            placeholder="अपना रजिस्टर्ड फोन नंबर डालें"
                            className={styles.input}
                            required
                        />
                    </div>

                    <div className={styles.formGroup}>
                        <label className={styles.label}>
                            ईमेल / Email <span className={styles.required}>*</span>
                        </label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="अपना रजिस्टर्ड ईमेल डालें"
                            className={styles.input}
                            required
                        />
                    </div>

                    <div className={styles.formGroup}>
                        <label className={styles.label}>
                            कारण (वैकल्पिक) / Reason (Optional)
                        </label>
                        <textarea
                            name="reason"
                            value={formData.reason}
                            onChange={handleChange}
                            placeholder="कृपया हमें बताएं कि आप अपना अकाउंट क्यों डिलीट करना चाहते हैं"
                            className={styles.textarea}
                            rows="4"
                        />
                    </div>

                    <div className={styles.checkboxGroup}>
                        <label className={styles.checkboxLabel}>
                            <input
                                type="checkbox"
                                name="confirmation"
                                checked={formData.confirmation}
                                onChange={handleChange}
                                className={styles.checkbox}
                                required
                            />
                            <span>
                                मैं पुष्टि करता/करती हूं कि मैं अपना StyleLink अकाउंट और सभी संबंधित डेटा को स्थायी रूप से डिलीट करना चाहता/चाहती हूं।
                                <br />
                                I confirm that I want to permanently delete my StyleLink account and all associated data.
                            </span>
                        </label>
                    </div>

                    {error && (
                        <div className={styles.errorMessage}>
                            {error}
                        </div>
                    )}

                    <div className={styles.buttonGroup}>
                        <button
                            type="submit"
                            className={styles.submitButton}
                            disabled={loading}
                        >
                            {loading ? 'प्रोसेस हो रहा है... / Processing...' : 'अकाउंट डिलीट करने का अनुरोध / Request Account Deletion'}
                        </button>
                        <a href="/" className={styles.cancelButton}>
                            रद्द करें / Cancel
                        </a>
                    </div>
                </form>

                <div className={styles.footer}>
                    <p className={styles.footerText}>
                        कोई समस्या? हमसे संपर्क करें / Need help? Contact us:
                    </p>
                    <p className={styles.contactInfo}>
                        <a href="mailto:support@stylelink.in" className={styles.link}>support@stylelink.in</a>
                        {' | '}
                        <a href="tel:+911234567890" className={styles.link}>+91 123-456-7890</a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default DeleteCandidateAccount;